import React, { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import SVG from 'react-inlinesvg';
import { find, flatMapDeep } from 'lodash';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import InputAdornment from '@material-ui/core/InputAdornment';
import Input from '@material-ui/core/Input';
import Hidden from '@material-ui/core/Hidden';
import Avatar from '@material-ui/core/Avatar';
import { buildAvatarName } from '../../../shared/helpers/buildAvatarName';
import homeRoutes from '../../routes/homeRoutes';
import styles from './header.module.scss';

import ProfileCard from '../ProfileCard/ProfileCard';

export default memo(function Header(props) {
    const [t] = useTranslation('home');
    const routeData = useMemo(() => {
        const allRoutes = flatMapDeep(homeRoutes.routes, route => route.routes ? [route, route.routes] : route);

        return find(allRoutes, route => {
            const splittedRoute = route.path.split('/');
            const splittedPathName = props.location.pathname.split('/');

            if (splittedRoute.length === 3 && splittedPathName.length === 3 && splittedRoute[1] === splittedPathName[1]) {
                return true;
            }

            return route.path === props.location.pathname;
        });
    });

    return (
        <AppBar position="static">
            <Toolbar className={styles.toolbarOptionsContainer} variant="dense">
                <div className={styles.siteInfoContainer}>
                    <Hidden smUp>
                        <IconButton aria-label="Open drawer" color="inherit">
                            <MenuIcon />
                        </IconButton>
                    </Hidden>
                    {!props.edition.user && !props.userGroupEdition.group && <span>{t(routeData.title)}</span>}
                    {!props.edition.user && !props.userGroupEdition.group && <span>{t(routeData.description)}</span>}
                    {props.edition.user && <span>{props.edition.user.Names} {props.edition.user.LastNames}</span>}
                    {props.edition.user && <span>{props.edition.user.Emails}</span>}
                    {props.userGroupEdition.group && <span>{props.userGroupEdition.group.Name}</span>}
                    {props.userGroupEdition.group && <span>{props.userGroupEdition.group.Description}</span>}
                </div>
                <div className={styles.userInfoContainer}>
                    {/* <Input
                        className={styles.search}
                        endAdornment={
                            <InputAdornment position="end">
                                <SVG cacheGetRequests className={styles.searchIcon} src="./icons/search.svg" />
                            </InputAdornment>
                        }
                        placeholder={t('SEARCH')}
                    /> */}
                    {/* <SVG cacheGetRequests className={styles.icon} src="./icons/notifications.svg" /> */}
                    <div className={styles.avatarContainer}>
                        <Avatar className={styles.avatar}>{buildAvatarName(props.username)}</Avatar>
                        {/* <ProfileCard /> */}
                    </div>
                </div>
            </Toolbar>
        </AppBar>
    );
});
